import style from "./style.module.scss"

import { Text } from "ui-kit/components-branded/index"

export function AutoPaymentText() {
    return (
        <Text className={style.text}>
            При самостоятельной записи сможете оплачивать сессии в&nbsp;один клик. <br /> Если вас
            запишет психолог&nbsp;&mdash; оплату спишем автоматически.
        </Text>
    )
}
